import { Get } from "services/api-inventory.service";
import { ApiPath } from "paths";

export const getLocation = async ({ locationId }) => {
	const res = await Get(`${ApiPath.LOCATION_ID(locationId)}`);
	return res;
};
